export default { title: 'Lataa Google-arvostelu' };
